// @flow
import DepositReport from './DepositReport'
export default () => ({
  path: 'deposit-report',
  element: <DepositReport />,
})
